/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{-webkit-box-flex:1;flex:1}[_nghost-%COMP%]   .referrals-page[_ngcontent-%COMP%]{height:100%}[_nghost-%COMP%]   .referrals-page[_ngcontent-%COMP%]   .ReferralsPageIFrame[_ngcontent-%COMP%]{border:0;width:100%;height:100%}"];
export { styles as styles };
//# sourceMappingURL=referrals-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/referrals/referrals-page/referrals-page.component.scss.shim.ngstyle.js
// module id = 1748
// module chunks = 27 28 29